import React from 'react'
import Base from '../core/Base'
const UserDashBoard = () => {
  return (
    <Base title='User DashBoard page'>
        <h1>This is user DashBoard page</h1>
    </Base>
  )
}

export default UserDashBoard;